import { render, staticRenderFns } from "./new-sole-good.vue?vue&type=template&id=cc3dfb5e&scoped=true"
import script from "./new-sole-good.vue?vue&type=script&lang=js"
export * from "./new-sole-good.vue?vue&type=script&lang=js"
import style0 from "./new-sole-good.vue?vue&type=style&index=0&id=cc3dfb5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3dfb5e",
  null
  
)

export default component.exports